import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { jumpToTop } from "@/motion/SmoothScroll";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  /* Routed through Lenis rather than window.scrollTo: while smoothing is
     running, setting the browser's scroll position directly leaves Lenis's
     own target where the visitor had been, and its next frame animates the new
     page back down to it. `jumpToTop` falls back to window.scrollTo when
     Lenis is not mounted, which is the reduced-motion path. */
  useEffect(() => {
    jumpToTop();
  }, [pathname]);

  return null;
}
